const it = {
  nav: {
    identita: 'Identità',
    prodotti: 'Prodotti',
    attivita: 'Attività',
    servizi: 'Servizi',
    contatti: 'Contatti',
    openMenu: 'Apri menu',
    closeMenu: 'Chiudi menu',
  },
  hero: {
    title1: 'NASCIAMO DALLA NATURA',
    title2: 'PER COSTRUIRE UN MONDO',
    title3: 'SOSTENIBILE',
    cta: 'Scopri di più',
    scroll: 'Scroll',
  },
  intro: {
    eyebrow: 'Identità',
    title: 'SIAMO MATERIA, TERRA, CRESCITA E STORIA',
    body:
      "FIBER PLAST è specializzata nella fabbricazione di tubazioni e serbatoi in vetroresina e in materiale termoplastico rinforzato, grazie a processi di produzione all’avanguardia in tutto il mondo. Utilizzando la tecnologia Filament Winding proprietaria, FIBER PLAST progetta, realizza e distribuisce in oltre 30 paesi al mondo prodotti tailor-made secondo le esigenze dei clienti, per centrali elettriche, industrie chimiche, petrolchimiche, power, aerospaziali e navali.",
  },
  products: {
    eyebrow: 'Prodotti',
    title: "L'ENERGIA DELLA FIBRA DI VETRO",
    subtitle: 'Soluzioni tailor-made in vetroresina e materiali termoplastici rinforzati realizzate con tecnologia Filament Winding proprietaria.',
    all: 'Tutti i prodotti',
    discover: 'Scopri di più',
    back: 'Tutti i prodotti',
    others: 'ALTRI PRODOTTI',
    request: 'Richiedi informazioni',
    features: [
      'Tecnologia Filament Winding proprietaria',
      'Materiali in vetroresina (PRFV) e termoplastici rinforzati',
      'Resistenza chimica e meccanica certificata',
      'Produzione tailor-made su disegno cliente',
      'Distribuzione in oltre 30 paesi nel mondo',
    ],
  },
  activity: {
    eyebrow: 'Attività',
    title: 'PROGETTI PER IL FUTURO',
    body: 'FIBER PLAST progetta e realizza tubature, serbatoi e manufatti vari (ad esempio canali, torri di raffreddamento, celle elettrolitiche) per usi civili e industriali. Distribuiamo in oltre 30 paesi al mondo prodotti tailor-made secondo le esigenze dei clienti.',
    sinceLabel: 'Dal 1978',
    sinceText: 'Oltre 45 anni di esperienza nei materiali compositi, dal cuore della Sardegna al mondo.',
    cta: 'Scopri di più',
    approachTitle: 'IL NOSTRO APPROCCIO',
    sectorsTitle: 'SETTORI DI APPLICAZIONE',
    intro: 'FIBER PLAST progetta e realizza tubature, serbatoi e manufatti vari — ad esempio canali, torri di raffreddamento, celle elettrolitiche — per usi civili e industriali. Operiamo a fianco dei nostri clienti dalla fase di progettazione fino al collaudo in campo, garantendo qualità, sostenibilità e ottimizzazione dei costi in ogni step.',
    steps: [
      { t: 'Analisi delle esigenze', d: 'Studio dettagliato dei requisiti tecnici e di processo del cliente.' },
      { t: 'Progettazione ingegneristica', d: 'Sviluppo di soluzioni custom in vetroresina e termoplastici rinforzati.' },
      { t: 'Produzione Filament Winding', d: "Realizzazione con tecnologia proprietaria all'avanguardia." },
      { t: 'Test & collaudo', d: 'Controlli qualità secondo i più alti standard di settore.' },
      { t: 'Trasporto & installazione', d: 'Logistica, assistenza in cantiere e supporto post-vendita.' },
    ],
  },
  services: {
    eyebrow: 'Servizi',
    title: 'INGEGNERIA GREEN',
    body: 'FIBER PLAST effettua assistenza e montaggio dei materiali forniti. Progetta i suoi prodotti e si occupa di imballaggio e trasporto nel rispetto delle richieste cliente, garantendo continuità e qualità in ogni fase del progetto.',
  },
  identita: {
    eyebrow: 'Identità',
    title: 'NASCIAMO DALLA NATURA PER COSTRUIRE UN MONDO SOSTENIBILE',
    blocks: [
      {
        title: 'Siamo materia',
        body:
          "Il driver materico della produzione FIBER PLAST è la vetroresina, che nasce dall’alleanza di due elementi presenti in natura: da una parte le fibre, dall’altra la resina. Una coesistenza durevole che fa da genesi alla creazione di opere e infrastrutture che costellano la vita di tutti i giorni: tubazioni, serbatoi, torri di abbattimento, filtri in PRFV e materiale termoplastico rinforzato, ma anche manufatti speciali come canali, torri di raffreddamento, celle elettrolitiche.",
      },
      {
        title: 'Siamo terra',
        body:
          "La solidità della nostra storia aziendale è racchiusa nella terra in cui nasciamo. Un punto di forza che esprime i nostri valori e la nostra esperienza. FIBER PLAST nasce nel cuore del Mar Mediterraneo, nel territorio di un’Isola, la Sardegna, dove natura e ambiente convivono armonicamente con la crescita e lo sviluppo delle imprese.",
      },
      {
        title: 'Siamo crescita',
        body:
          "L’azienda opera dal 1978, nel mercato locale, per poi espandersi oltre confine. Oggi l’azienda mira ad ampliare ulteriormente il network general contractor nei paesi in cui lavora, attraverso un elevato know how e l’utilizzo di materie prime di qualità che caratterizzano ogni progetto. Un tratto distintivo capace di espandere il brand FIBER PLAST in tutto il mondo.",
        quote:
          "Nasciamo nel cuore del Mar Mediterraneo, nel territorio di un’Isola, la Sardegna, dove natura e ambiente convivono armonicamente favorendo la crescita e lo sviluppo delle imprese.",
      },
      {
        title: 'Siamo storia',
        body:
          "I materiali compositi sono costituiti dall’unione di due o più materiali (matrice, fibre, additivi). Dalla loro combinazione nasce un prodotto leggero, resistente e durevole, con applicazioni nei settori aerospaziale, automobilistico, sportivo, elettrotecnico ed edilizio.",
      },
    ],
  },
  contact: {
    eyebrow: 'Contatti',
    title: 'PARLIAMO DEL TUO PROGETTO',
    body: 'Vuoi avere ulteriori informazioni su uno dei nostri servizi o sui nostri prodotti? Desideri fornirci un feedback o hai una richiesta particolare? Compila il form, sarai contattato il prima possibile.',
    fields: { name: 'Nome', surname: 'Cognome', email: 'Email', message: 'Messaggio' },
    privacy: 'Ho letto e accetto la',
    privacyLink: 'Privacy Policy',
    submit: 'Invia',
    submitting: 'Invio…',
    okTitle: 'Messaggio inviato',
    okBody: 'Ti risponderemo il prima possibile.',
    errMissing: 'Compila nome, email e messaggio.',
    errMissingTitle: 'Campi mancanti',
    errPrivacyTitle: 'Privacy Policy',
    errPrivacy: 'Devi accettare la Privacy Policy per inviare.',
  },
  contatti: {
    legalOffice: 'Sede Legale',
    opOffice: 'Sede Operativa',
    phone: 'Telefono',
    fax: 'Fax',
  },
  footer: {
    opOffice: 'Sede Operativa',
    nav: 'Naviga',
    tagline: 'Made in Sardegna · Distribuito in oltre 30 paesi',
    rights: 'Tutti i diritti riservati.',
    privacy: 'Privacy & Cookie Policy',
  },
  cta: {
    title: "DALLA NATURA, PER L'INDUSTRIA DI DOMANI",
    body: 'Materiali compositi leggeri, resistenti e durevoli per centrali, impianti chimici, navali e aerospaziali in oltre 30 paesi.',
    button: 'Contattaci',
  },
  video: {
    eyebrow: 'Video',
    title: 'FIBER PLAST IN AZIONE',
    body: 'Scopri la nostra tecnologia Filament Winding proprietaria e i processi produttivi che rendono unici i manufatti FIBER PLAST, dalla progettazione alla consegna.',
    stat1: 'Anni',
    stat2: 'Paesi',
    stat3: 'mm max',
  },
  stats: [
    { value: '45+', label: 'Anni di esperienza' },
    { value: '30+', label: 'Paesi serviti' },
    { value: '5000', label: 'mm diametro max' },
    { value: '1978', label: 'Anno di fondazione' },
  ],
  sectors: ['Centrali elettriche', 'Industria chimica', 'Petrolchimico', 'Power', 'Aerospaziale', 'Navale'],
};

export default it;
